import React from "react";
import ReactDOM from 'react-dom';
import "./styles.css";

const ComplaintModal = ({ children, isOpen, onClose, onConfirm }) => {

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="complaint-modal-overlay">
            <div className="complaint-modal-container">
                <h3 className="complaint-modal-header">Leave an issue comment</h3>
                <div className="complaint-modal-body">{children}</div>
                <div className="complaint-modal-footer">
                    <button className="complaint-cancel-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="complaint-confirm-btn" onClick={onConfirm}>
                        Confirm
                    </button>
                </div>
            </div>
        </div>,
        document.getElementById('modal-root')
    );
};

export default ComplaintModal;
